export async function fetchJson(
  url,
  body = {},
  { method = `POST`, allowErrorResponse = false } = {}
) {
  const response = await window.fetch(url, {
    method,
    headers: {
      accept: `*/*`,
      "content-type": `application/json`,
      "x-csrf-token": document
        .querySelector(`meta[name='csrf-token']`)
        ?.getAttribute(`content`),
    },
    body: JSON.stringify(body),
  })

  if (!allowErrorResponse && !response.ok && !response.redirected)
    throw new Error(
      `Could not fetch ${url} (${response.status}: ${response.statusText})`
    )

  return response
}
